module.exports = __webpack_public_path__ + "static/purchasing-static-76254b6c1e12f887421fa3df5d96606d.jpg";